export enum ContentType {
  ARTICLE_STANDARD = 'articleStandard',
  SERVICE = 'service',
  TOPIC = 'topic',
  EDITORIAL_PAGE = 'editorialPage',
  VEHICLE_VALUATION = 'vehicleValuation',
}

export const supportedTypes = Object.values(ContentType);
